import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Accordion, CopyWarning } from '@citi-gcg-173875/citi-common-ui';
import { FormsModule } from '@angular/forms';
import { RafRoutingModule } from './raf-routing.module';
import { MktCommonModule } from '../../common/mkt-common.module';
import { RafComponent } from './raf.component';
import { ProductV23Component } from 'src/app/common/components/product-v23/product-v23.component';
@NgModule({
  declarations: [
    RafComponent,
  ],
  imports: [
    CommonModule,
    RafRoutingModule,
    MktCommonModule,
    Accordion,
    CopyWarning,
    FormsModule,
    ProductV23Component
  ],
})
export class RafModule { }
